import React from "react";
import { useNavigate } from "react-router-dom";
import CreateStarChartActionPresentation from "../../presentation/createStarChart/CreateStarChartActionPresentation";
import StarChartAssignOrganizationContainer from "../starChart.assign.organization.container/StarChartAssignOrganizationContainer";
type ExperienceActionContainerProps = {
  onTerm: (e: React.ChangeEvent<HTMLInputElement>) => void;
  listStatus: string;
  onOrganizations: () => void;
  onExperiences: () => void;
  term: string;
  lastPosition: number;
  onstarChartAssignArg: () => void,
  starChartAssignArg: boolean,
};
const CreateStarChartActionContainer: React.FC<ExperienceActionContainerProps> = ({
  onTerm,
  listStatus,
  onOrganizations,
  onExperiences,
  term,
  lastPosition,
  onstarChartAssignArg,
  starChartAssignArg
}) => {
  const navigation = useNavigate()
  const onCreateExperience = () => {
    navigation('/experience/expdetails',{state : {isPrerequisites : false, lastPosition : lastPosition}})
  }

  return (
    <>
            <CreateStarChartActionPresentation
              onCreateExperience={onCreateExperience}
              onTerm={onTerm}
              listStatus={listStatus}
              onOrganizations={onOrganizations}
              onExperiences={onExperiences}
              term={term}
              openStarChartAssignOrg={onstarChartAssignArg}
              
            />
      
            
        <StarChartAssignOrganizationContainer starChartAssignArg={starChartAssignArg} assignArgPopup={onstarChartAssignArg} />
        
    </>
   )

}

export default CreateStarChartActionContainer
